import React from 'react';
import { formatHHMMSS, formatMs, parseEstimatedMs } from '../utils/timeFormatters';

export default function EffortBar({ estimatedTime, actualTimeMs, remainingTimeMs }) {
    const estimatedMs = parseEstimatedMs(estimatedTime);
    const pct = estimatedMs > 0 ? Math.min(Math.round((actualTimeMs / estimatedMs) * 100), 100) : 0;
    const overrun = estimatedMs > 0 && actualTimeMs > estimatedMs;

    return (
        <div className="space-y-1.5">
            <div className="flex justify-between items-center">
                <span className="text-xs font-semibold text-[#424750] dark:text-slate-400">Effort</span>
                <div className="flex items-center gap-2 text-xs font-bold">
                    <span className={overrun ? 'text-red-500' : 'text-[#191c1d] dark:text-white'}>{formatMs(actualTimeMs)}</span>
                    <span className="text-[#737782] dark:text-slate-500">/ {estimatedTime || '-'}</span>
                    {estimatedMs > 0 && <span className={overrun ? 'text-red-500' : 'text-[#424750] dark:text-slate-400'}>({pct}%)</span>}
                    {remainingTimeMs !== null && <span className="text-[#737782] dark:text-slate-500">Remaining {formatHHMMSS(remainingTimeMs)}</span>}
                </div>
            </div>
            <div className="h-2 bg-[#e7e8e9] dark:bg-[#334155] rounded-full overflow-hidden">
                <div
                    className={`h-full rounded-full transition-all duration-500 ${overrun ? 'bg-red-400' : 'bg-gradient-to-r from-[#03488a] to-[#00AAF1]'}`}
                    style={{ width: `${pct}%` }}
                />
            </div>
        </div>
    );
}

